import React, { useEffect, useState } from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import { Box, Stack } from '@mui/material';
import CusInput from '../../../components/material-ui/CusInput';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import CusPassword from '../../../components/material-ui/CusPassword';
import CusItemTooltip from '../../../components/material-ui/CusItemTooltip';
import { IconRefresh } from '@tabler/icons-react';
import useColor from '../../../hooks/site/useColor';
import CusButton from '../../../components/material-ui/CusButton';
import { useTranslation } from 'react-i18next';
import { API_USERS } from '../../../api/users';
import useToast from '../../../hooks/useToast';
import CusPassWitchGen from '../../../components/material-ui/CusPassWitchGen';

export default function ChangePas({ open, closeModal, user }) {
  const { t } = useTranslation();
  const { successToast } = useToast();
  const [password, setPassword] = useState('');

  const title = `${t('Change user password')} ${user?.login}`;

  const onSaveClick = () => {
    API_USERS.info.pas
      .set({ userId: user.userId, psword: password })
      .then((e) => {
        successToast('Password updated successfully');
        closeModal();
      })
      .catch(console.error);
  };

  return (
    <InfoDialog
      open={open}
      onClose={closeModal}
      title={title}
      maxWidth="xs"
      onSaveClick={onSaveClick}>
      <ShowContainer condition={open} plug={<div style={{ height: '130px' }}></div>}>
        <Stack display={'flex'} gap={1}>
          <CusPassWitchGen
            autoFocus={open}
            password={password}
            setPassword={setPassword}
            genParam={{ length: 20 }}
          />
        </Stack>
      </ShowContainer>
    </InfoDialog>
  );
}
